import { useCallback } from 'react';
import { Controller, type ControllerRenderProps, type UseFormReturn } from 'react-hook-form';
import { useFormMethods } from '@hqo/multi-step-form';
import { Checkbox, CheckedState } from '@hqo/ui-atoms';
import type { CreateVisitFormV2Values } from '../../../../types/form-data.types';
import { useValidationMessage } from '../../../../hooks/use-validation-message.hook';

interface AcknowledgmentTextProps {
  acknowledgmentText: string | undefined;
}

export const AcknowledgmentText = ({ acknowledgmentText }: AcknowledgmentTextProps): JSX.Element | null => {
  const formatValidationMessage = useValidationMessage();
  const form = useFormMethods() as unknown as UseFormReturn<CreateVisitFormV2Values>;
  const { control } = form;

  const handleCheckedChange = useCallback(
    (field: ControllerRenderProps<CreateVisitFormV2Values, 'acknowledgmentConfirmed'>) => (checked: CheckedState) =>
      field.onChange(checked === true),
    [],
  );

  if (!acknowledgmentText) {
    return null;
  }

  return (
    <Controller
      name="acknowledgmentConfirmed"
      control={control}
      // eslint-disable-next-line react/jsx-no-bind
      render={({ field, fieldState }) => (
        <div className="space-y-2" data-cy="acknowledgment-text">
          <label htmlFor="acknowledgmentConfirmed" className="flex items-start gap-3 cursor-pointer">
            <Checkbox
              id="acknowledgmentConfirmed"
              checked={field.value ?? false}
              onCheckedChange={handleCheckedChange(field)}
              className="mt-0.5"
              data-cy="acknowledgment-checkbox"
            />
            <span className="text-sm text-foreground">{acknowledgmentText}</span>
          </label>
          {fieldState.error && (
            <p className="text-sm text-destructive">{formatValidationMessage(fieldState.error.message)}</p>
          )}
        </div>
      )}
    />
  );
};
